const mutations = {
  SET_PUBLIC_PLANS(state, plans) {
    state.publicPlans = plans;
  },
  SET_ADMIN_PLANS(state, plans) {
    state.adminPlans = plans;
  },
  UPDATE_PLAN(state, plan) {
    const idx = state.adminPlans.findIndex((p) => p.id === plan.id);
    if (idx !== -1) state.adminPlans.splice(idx, 1, plan);
  },
  REMOVE_PLAN(state, id) {
    state.adminPlans = state.adminPlans.filter((p) => p.id !== id);
  },
};

export default mutations;
